export const DEFAULT_LIST_PREVIEW_LIMIT = 20;

export function hasActiveListSearch(query: string): boolean {
  return query.trim().length > 0;
}

export function getVisibleListRows<T>(
  rows: T[],
  query: string,
  limit: number = DEFAULT_LIST_PREVIEW_LIMIT
): T[] {
  return hasActiveListSearch(query) ? rows : rows.slice(0, limit);
}
